module.exports = __webpack_public_path__ + "img/4.b659f0b3.png";